import './index.less';
import classNames from 'classnames';
const insertRipple = props => {
  const {
    className,
    ref
  } = props;
  if (ref !== null && ref !== void 0 && ref.getElementsByClassName('ripple').length) return;
  const Ripple = document.createElement('div');
  Ripple.className = classNames(className, 'ripple');
  ref === null || ref === void 0 || ref.appendChild(Ripple);
};
export default insertRipple;